'use strict';

const Rx = require('../../rlink-rx');
const {xhr} = require('../../rlink-utils/xhr');
const embedded = require('../../rlink-data-connector/embedded');
const setRequestPending = require('../../rlink-data-connector/setRequestPending');
const {P4_RELAY_URL} = require('../../rlink-p4/constants');

module.exports = function p4RelayRequestStream ({
  method,
  mapCallToPath,
  mapResponse,
  headers,
}) {
  return ({request, requestArgs}) => Rx.Observable.create(observer => {
    observer.onNext([setRequestPending(request, requestArgs)]);

    xhr(
      method, `${P4_RELAY_URL}/${mapCallToPath(...requestArgs)}`, null, headers
    ).then(responseEnvelope => {
      observer.onNext([
        embedded(request, requestArgs, mapResponse(responseEnvelope.response)),
      ]);
      observer.onCompleted();
    }).catch(err => {
      observer.onError(err);
    });
  });
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/streams/p4RelayRequestStream.js